import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import { purple, green, red, blue, indigo, teal, grey } from '@material-ui/core/colors';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import CustomButtonOLLight from './CustomButtonOLLight';
import CustomButtonOLDailyBlue from './CustomButtonOLDailyBlue';
import CustomButtonOLDailyDigital from './CustomButtonOLDailyDigital';
import NewsList from './NewsList';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

/**
* 折り畳み表示
* 'openHere'というクラスに属するオブジェクトをインライン要素or非表示に変更する。
*/
const openClose = (id) => {
  console.log(id);
  var obj = document.getElementsByClassName(`openHere ${id}`);
  for(var i=0;i<obj.length;i++){
      //非表示ならインライン要素に変更。表示状態なら非表示に変更。
      if(obj[i].style.display == "inline-block"){
          obj[i].style.display = "none";
      }
      else{
          obj[i].style.display = "inline-block";
      }
  }
}

const testClick = () => {
  alert(`ボタンがクリックされました`);
}

function Home() {
  const classes = useStyles();
  {/*
  // お知らせテスト
  window.onload = function () {
  // ロード時にAPIを呼び出す
    const API_URL = "https://api.sssapi.app/vPxrQ3DPI0c3Dg9o4AOrC";
    fetch(API_URL).then((response) => {
      if (response.status != 200) {
        // APIの呼び出しが失敗した場合
        console.log(response.status);
        return response
          .json()
          .then((error) => alert(JSON.stringify(error, null, 2)));
      }

      // APIの呼び出しが成功した場合
      return response
        .json() // JSONデータを取得
        .then((data) => {
          // 取得したデータを挿入
          document.getElementById("infomation").innerHTML += `<span onclick={testClick}>ここをクリック</span>`;
        });
    });
  };
  */}

  return (
    <div className={classes.root}>
      <div className="wrap">
        {/* <video autoPlay muted playsInline loop id="bg-video">
          <source src="/movie/movie-bg.webm" type="video/webm"></source>
          <source src="/movie/movie-bg.mp4" type="video/mp4"></source>
          <source src="/movie/movie-bg.ogg" type="video/ogg"></source>
        </video> */}
        <Box className="content-wrap">
          <div className="header-title">
            {/*
              <Grid className="p-3 my-4" spacing={0} container direction="row" justify="center">
                <Grid item xs={10} sm={8} md={6}>
                  <img src="/images/logo-top.png" className="img-fluid" />
                </Grid>
              </Grid>
            */}
            <div className="top-menu-wrap">
              <div className="top-menu-content">
                <Typography className="text-left my-3" variant="h6" component="h2">デーリー東北からのお知らせ</Typography>
                <NewsList/>
              </div>

              <div className="top-menu-content">
                <Typography className="text-left my-3" variant="h6" component="h2">会社案内</Typography>
                <Grid spacing={1} container direction="row" justify="left" alignItems="center">
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/guide-overview" className="aaa px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">会社概要</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="https://recruit.daily-tohoku.company/" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">採用情報</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/guide-shop" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">購読のご案内</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/guide-advertisement" className="aaa px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">広告・折込のご案内</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                </Grid>
              </div>

              <div className="top-menu-content">
                <Typography className="text-left my-3" variant="h6" component="h2">事業・チケット案内</Typography>
                <Grid spacing={1} container direction="row" justify="left" alignItems="center">
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="https://event-guide.daily-tohoku.news/#sec-event" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">主催事業</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="https://event-guide.daily-tohoku.news/#sec-ticket" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">チケット情報</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/forum" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">政経懇話会</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                </Grid>
              </div>

              <div className="top-menu-content">
                <Typography className="text-left my-3" variant="h6" component="h2">各種サービス</Typography>
                <Grid spacing={1} container direction="row" justify="left" alignItems="center">
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/guide-delion" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">デリオンくらぶ</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/guide-facility" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">ホール貸出</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/book" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">書　籍</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/support" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">後援願い</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="https://form.daily-tohoku.org/" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">バックナンバー販売</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/printservice" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">掲載写真販売</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/tour" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">会社見学</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/guide-service" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">NIE</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={8} md={6}>
                    <CustomButtonOLDailyDigital href="https://www.daily-tohoku.news" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">デーリー東北デジタルへ　<i class="fas fa-arrow-circle-right"></i></div>
                    </CustomButtonOLDailyDigital>
                  </Grid>
                </Grid>
              </div>

              <div className="top-menu-content">
                <Typography className="text-left my-3" variant="h6" component="h2">投稿・各種お問い合わせ</Typography>
                <Grid spacing={1} container direction="row" justify="left" alignItems="center">
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/guide-wanted" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">投稿・応募</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/guide-contactus" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">お問い合わせ</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  {/*
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue id="open" href="/info" className="px-1 py-2 d-block" size="small" themeColor={grey}>
                      <div className="absolute-transform line160">関連会社役員の新型コロナ<br />ウイルス感染について</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <CustomButtonOLDailyBlue id="open" href="javascript:void(0);" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">もっと「つかって」デーリー東北</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  */}
                </Grid>
              </div>
            </div>
          </div>
          {/*
          <div className="d-none d-md-block">
            <img src="/images/da002.png" className="img-fluid" />
          </div>
          */}
        </Box>
      </div>
    </div>
  );
}

export default Home;
